import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'test-core-header-tools',
  templateUrl: `./header-tools.component.html`,
  standalone: true,
  styleUrls: [`./header-tools.component.scss`]
})
export class HeaderToolsComponent {
  constructor(private readonly router: Router) {}

  navigateToOtherComponent(path: string[]) {
    this.router.navigate(path);
  }

  refreshJmkw() {
    // Logic to refresh or reinitialize the jmkw component
    // This could involve resetting the state or re-fetching data
    console.log('Refreshing JMKW component...');
  }
}
